import {
  LuGlobe,
  LuFlaskConical,
  LuHeartPulse,
  LuHeartHandshake,
  LuTrees,
  LuUsersRound,
} from 'react-icons/lu'
const pillars = [
  { n: '01', title: 'Traditional African & Caribbean Healing Wisdom' },
  { n: '02', title: 'Modern Herbal Science' },
  { n: '03', title: 'Holistic Lifestyle Practices' },
  { n: '04', title: 'Emotional & Spiritual Wellbeing' },
  { n: '05', title: 'Nature-Based Living' },
  { n: '06', title: 'Community Education & Empowerment' },
]

const pillarIcons = [LuGlobe, LuFlaskConical, LuHeartPulse, LuHeartHandshake, LuTrees, LuUsersRound]

export const PillarsSection = () => (
  <section
    aria-labelledby="approach-heading"
    className="bg-green-950 py-16 text-base-50 sm:py-20 lg:py-24"
  >
    <div className="mx-auto max-w-6xl px-6">
      <div className="mb-10 grid gap-5 lg:grid-cols-2 lg:gap-16">
        <div>
          <h2
            id="approach-heading"
            className="font-display text-3xl leading-tight tracking-tight sm:text-4xl lg:text-5xl"
          >
            People. Plants.
            <br />
            <span className="text-gold-200">Connection.</span>
          </h2>
        </div>
        <div className="max-w-lg self-end space-y-4 text-base leading-7 text-green-100">
          <p>
            Instrumental Health is not simply a wellness brand. It is an educational and healing
            platform bridging centuries of indigenous wisdom with the rigour of modern science.
          </p>
          <p>
            Our mission is to awaken people to conscious control of their health, rooted in nature,
            knowledge, community, and the intelligence of the body.
          </p>
        </div>
      </div>
      <div className="grid gap-8 border-t border-white/15 pt-8 md:grid-cols-3">
        {pillars.map((pillar, i) => {
          const PillarIcon = pillarIcons[i]
          return (
            <div key={pillar.title}>
              <PillarIcon aria-hidden="true" className="h-6 w-6 text-gold-200" />
              <h3 className="mb-3 mt-4 font-display text-2xl">{pillar.title}</h3>
            </div>
          )
        })}
      </div>
    </div>
  </section>
)
